import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteBookingCheckinsService = async (
  checkinId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/bookings/checkins/${checkinId}`);
};

export default deleteBookingCheckinsService;
